(() => {
  const purchasesEnabled = document.body.dataset.purchasesEnabled === 'true';
  const campaignParameters = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'fbclid',
  ];

  const forwardCampaignParameters = (root = document) => {
    const sourceParameters = new URL(window.location.href).searchParams;
    if (!campaignParameters.some((parameter) => sourceParameters.has(parameter))) return;

    root.querySelectorAll('[data-portrait-app-link]').forEach((link) => {
      const href = link.getAttribute('href');
      if (!href) return;

      try {
        const destination = new URL(href, window.location.href);
        if (destination.protocol !== 'https:' && destination.protocol !== 'http:') return;

        campaignParameters.forEach((parameter) => {
          if (!sourceParameters.has(parameter)) return;

          destination.searchParams.delete(parameter);
          sourceParameters.getAll(parameter).forEach((value) => {
            destination.searchParams.append(parameter, value);
          });
        });

        link.href = destination.toString();
      } catch {
        // Leave an invalid merchant-configured destination untouched.
      }
    });
  };

  forwardCampaignParameters();
  document.addEventListener('shopify:section:load', (event) => {
    forwardCampaignParameters(event.target);
  });

  const syncHeaderBottom = () => {
    const header = document.querySelector('[data-site-header]');
    if (!header) return;
    document.documentElement.style.setProperty('--header-bottom', `${Math.max(0, Math.round(header.getBoundingClientRect().bottom))}px`);
  };

  let headerSyncFrame;
  const queueHeaderSync = () => {
    if (headerSyncFrame) return;
    headerSyncFrame = window.requestAnimationFrame(() => {
      headerSyncFrame = undefined;
      syncHeaderBottom();
    });
  };

  syncHeaderBottom();
  window.addEventListener('resize', queueHeaderSync, { passive: true });
  window.addEventListener('scroll', queueHeaderSync, { passive: true });
  document.addEventListener('shopify:section:load', queueHeaderSync);

  const openRequestedChat = () => {
    const parameters = new URL(window.location.href).searchParams;
    if (parameters.get('chat') !== 'open') return;

    const tryOpenChat = () => {
      const chat = document.querySelector('shopify-agent');
      const launcher = chat?.shadowRoot?.querySelector('button[aria-label="Chat"]');
      if (!(launcher instanceof HTMLButtonElement)) return false;

      launcher.click();
      return true;
    };

    if (tryOpenChat()) return;

    const observer = new MutationObserver(() => {
      if (tryOpenChat()) observer.disconnect();
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 15000);
  };

  openRequestedChat();

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const productInfo = select.closest('.product-info');
      const price = productInfo?.querySelector('[data-product-price]');
      if (price && option?.dataset.price) price.textContent = option.dataset.price;
    });
  });

  document.querySelectorAll('.mobile-menu a').forEach((link) => {
    link.addEventListener('click', () => link.closest('details')?.removeAttribute('open'));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('details[open].mobile-menu').forEach((menu) => menu.removeAttribute('open'));
  });

  if (!purchasesEnabled) {
    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      const action = form.getAttribute('action') || '';
      const checkoutAttempt = event.submitter?.getAttribute('name') === 'checkout';
      if (!action.includes('/cart/add') && !checkoutAttempt) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const gate = form.closest('.product-form__buttons, .cart-summary')?.querySelector('.commerce-gate');
      gate?.setAttribute('tabindex', '-1');
      gate?.focus();
    }, true);
  }
})();
